import React from "react";

const TutorPayrollLoadingState = () => {
  const styles = {
    loadingContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "4rem 0",
    },
    spinner: {
      border: "3px solid #f3f3f3",
      borderTop: "3px solid #001272",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      animation: "spin 1s linear infinite",
      marginBottom: "1rem",
    },
  };

  return (
    <div style={styles.loadingContainer}>
      <div style={styles.spinner}></div>
      <p style={{ color: "#001272", marginTop: "1rem" }}>
        Loading payroll details...
      </p>
    </div>
  );
};

export default TutorPayrollLoadingState;
